import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input"]

    connect() {
        // Optional: Focus on connect if needed, but iframe-autofocus handles that
    }

    clear() {
        this.inputTarget.value = ""
        this.inputTarget.focus()

        // Reset height if using autogrow
        this.inputTarget.style.height = "auto"
    }

    submitEnd(event) {
        if (event.detail.success) {
            this.clear()
        }
    }
}
